import { render, staticRenderFns } from "./nextBtn.vue?vue&type=template&id=2bd37b2d&scoped=true"
import script from "./nextBtn.vue?vue&type=script&lang=js"
export * from "./nextBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd37b2d",
  null
  
)

export default component.exports